import { useRef, type ReactElement } from 'react';
import { pickWithHandles } from '@/lib/file-handles';

/**
 * Picking files from any button; picked files go to `onFiles`. Where the
 * browser has the system dialog that gives handles (Chromium on computers),
 * that opens, so a saved project can find its files again by itself; elsewhere
 * a hidden file input does.
 */
export function useFilePicker(accept: string, onFiles: (files: File[]) => void, multiple = true): { readonly pick: () => void; readonly input: ReactElement } {
  const ref = useRef<HTMLInputElement>(null);
  const pick = async () => {
    const files = await pickWithHandles(accept, multiple);
    if (files === null) ref.current?.click();
    else if (files.length > 0) onFiles(files);
  };
  const input = (
    <input
      ref={ref}
      type="file"
      accept={accept}
      multiple={multiple}
      className="hidden"
      onChange={(event) => {
        const files = Array.from(event.target.files ?? []);
        event.target.value = '';
        if (files.length > 0) onFiles(files);
      }}
    />
  );
  return { pick: () => void pick(), input };
}
